import React from 'react'
import styles from '../../common.module.scss'
import dynamic from 'next/dynamic'

import ChangeLanguage from './ChangeLang'
import linkToHunt from 'helpers/linkToHunt'
import Link from 'next/link'
const MaintainNotification = dynamic(() => import('components/MaintainNotification'), {
  ssr: false
})
import { LogoTextIcon } from './icons'
import { Dropdown } from 'antd'
import { useMainResumeContext } from '../Main/context'
import Image from 'next/image'
import { postNotification } from 'bossjob-remote/dist/clientStorage'

export const CommonHeader = (props) => {
  const { lang = {}, langKey } = props
  const { userInfo } = useMainResumeContext()

  const handleLogOut = () => {
    postNotification('LOGOUT')
  }

  return (
    <div className={styles.header}>
      <MaintainNotification lang={props.lang} langKey={langKey} />
      <div className={styles.headerContainer}>
        <div className={styles.logo}>
          <Link href={`/${langKey}`}>
            <LogoTextIcon />
          </Link>
        </div>
        <div className={styles.headerRight}>
          <Link href={linkToHunt('boss')} className={styles.link}>
            {lang?.profile?.ImHiring}
          </Link>
          <ChangeLanguage />

          <Dropdown
            trigger={['click', 'hover']}
            overlayStyle={{ zIndex: 2002 }}
            placement='bottomRight'
            dropdownRender={() => {
              return (
                <div className={styles.dropdownContainer}>
                  <div className={styles.dropdownItem} onClick={handleLogOut}>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='17'
                      viewBox='0 0 16 17'
                      fill='none'
                    >
                      <path
                        d='M11.3333 3.83333V2.5H4C2.89543 2.5 2 3.39543 2 4.5V12.5C2 13.6046 2.89543 14.5 4 14.5H11.3333V13.1667H4C3.63181 13.1667 3.33333 12.8682 3.33333 12.5V4.5C3.33333 4.13181 3.63181 3.83333 4 3.83333H11.3333Z'
                        fill='#121212'
                      />
                      <path
                        d='M12.3905 9.16667L6.66667 9.16667V7.83333L12.3905 7.83333L10.8619 6.30474C10.6016 6.04439 10.6016 5.62228 10.8619 5.36193C11.1223 5.10158 11.5444 5.10158 11.8047 5.36193L14.4714 8.0286C14.7318 8.28895 14.7318 8.71106 14.4714 8.97141L11.8047 11.6381C11.5444 11.8984 11.1223 11.8984 10.8619 11.6381C10.6016 11.3777 10.6016 10.9556 10.8619 10.6953L12.3905 9.16667Z'
                        fill='#121212'
                      />
                    </svg>
                    {lang?.header?.logOut || 'Log Out'}
                  </div>
                </div>
              )
            }}
          >
            <div className={styles.userIconContainer}>
              {userInfo?.avatar ? (
                <Image
                  src={userInfo?.avatar}
                  width={40}
                  height={40}
                  alt='user'
                  className={styles.userIcon}
                />
              ) : null}
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  )
}
